import { v1 as uidv1 } from 'uuid'


// this file must be first import in /main.ts

window.contextId = uidv1()

window.addEventListener('message', (event) => {
  if (event.data?.event === 'PSExtReady') {
    // = chrome.runtime.id from browser extension, used in legacyApp
    window.extensionId = event.data.id
  }
})
